<template>
  <navbar navbar-menu-classes="navbar-right" v-model="showMenu">
    <div class="navbar-wrapper">
      <a class="navbar-brand" href="#">Home Design Furniture</a>
    </div>
    <template slot="navbar-menu">
      <!-- <router-link to="/register" class="nav-item" tag="li">
        <a class="nav-link">
          <i class="nc-icon nc-book-bookmark"></i> Register
        </a>
      </router-link> -->
      <ul class="navbar-nav profile">
      <router-link to="/login" class="nav-item" tag="li">
        <a class="nav-link">
          <i class="nc-icon nc-tap-01"></i> Login
        </a>
      </router-link>
      </ul>
    </template>
  </navbar>
</template>

<script>
  import {Navbar} from 'src/components/UIComponents'
  import Auth from'../../../../../Auth.js';
  export default {
    name: 'main-navbar',
    components: {
      Navbar
    },
    data() {
      return {
        showMenu: false,
            Auth:'',

      }
    },

    mounted() {
        this.Auth = Auth.user;
  
    },

  }
</script>
<style scoped>

</style>
